import { render, staticRenderFns } from "./splitScan.vue?vue&type=template&id=507723b0&"
import script from "./splitScan.vue?vue&type=script&lang=js&"
export * from "./splitScan.vue?vue&type=script&lang=js&"
import style0 from "./splitScan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports